// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/relatorios/extracoes.css
// module id = 1034
// module chunks = 0